import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import LandingPage from './LandingPage';
import { isAuthenticated, getLoginUserData } from '../../services/account.service';
import { ROLES } from '../../constants/general.constant';

const AuthAwareLanding = () => {
  const [isAuth, setIsAuth] = useState(false);
  const [role, setRole] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const authStatus = isAuthenticated();
      setIsAuth(authStatus);
      if (authStatus) {
        try {
          const user = await getLoginUserData();
          setRole(user?.role || null);
        } catch (error) {
          setIsAuth(false);
        }
      }
      setLoading(false);
    };
    checkAuth();
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  if (isAuth && role) {
    switch (role) {
      case ROLES.BUSINESS:
        return <Navigate to="/dashboard" replace />;
      case ROLES.CO_OWNER:
        return <Navigate to="/co-owner/leads" replace />;
      case ROLES.EMPLOYEE:
        return <Navigate to="/employee/leads" replace />;
      case ROLES.CUSTOMER:
        return <Navigate to="/customer/prospect-profile" replace />;
      case ROLES.BANKER:
        return <Navigate to="/banker/register" replace />;
      default:
        return <Navigate to="/login" replace />;
    }
  }

  return <LandingPage />;
};

export default AuthAwareLanding;

